import React from 'react';
import { Gesture } from '@mui/icons-material';
import { RichContent } from "@gisce/oficina-virtual-components";
import { i18n } from "../config";

const SignatureProcess = ({icon = <Gesture/>}) => {
  return (
    <div>
      {icon}
      <span style={{marginLeft: '10px'}}>
        <RichContent content={i18n.t('common:text.contracts_signature_process')} />
      </span>
    </div>
  );
};

export default SignatureProcess;
